export const USER_SIGNED_IN = "userSignedIn"
export const USER_SIGNED_OUT = "userSignedOut"